import ConsumptionReport from "../components/ConsumptionReport";
import { grossMarginConfig } from "../configs/grossMarginConfig";

const GrossMarginAtProductLevel = ({ outlets }) => {
  return (
    <ConsumptionReport {...grossMarginConfig} outlets={outlets} />
  )
};

export default GrossMarginAtProductLevel;
